export default __webpack_public_path__ + "static/media/card4.57a5ffaf.png";